
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, CanLoad, Route } from '@angular/router';
// 										local
import { UserProfile } from 'src/shared/models/user-profile.model';
import { Sandbox } from 'src/app';
import { PlatformService } from 'src/shared/services/platform.service';
import { map, Observable } from 'rxjs';

@Injectable()
export class AuthenticationGuard implements CanLoad, CanActivate {

	constructor(private $: Sandbox,
		private _platformService: PlatformService) { }

	private checkAuth(user: UserProfile): Observable<boolean> | boolean {
		if (!user || user.userId < 0) {
			var canActivate$ = this._platformService.userProfile.pipe(map((profile) => (profile.userId && profile.userId > 0)));
			return canActivate$;
		}
		var canActivate = true
			, canActivate = !!(canActivate && !!~user.userId);
		return canActivate;
	}

	canLoad(route: Route): Observable<boolean> | boolean {
		let canActivate = this.checkAuth(this.$.user);
		return canActivate;
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		let canActivate = this.checkAuth(this.$.user);
		return canActivate;
	}

}
